<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container class="content">
            <HotelInfo :id="result.id" :inhouse="result.is_inhouse" />
            <b-row>
              <b-col sm="12">
                <b-table-simple stacked="sm" class="table table-sm">
                  <b-thead class="t-head thead-light">
                    <b-tr>
                      <b-td><translate>Room Type</translate></b-td>
                      <b-td><translate>Meal</translate></b-td>
                      <b-td><translate>Check in</translate></b-td>
                      <b-td><translate>Check out</translate></b-td>
                      <b-td><translate>Nights</translate></b-td>
                    </b-tr>
                   </b-thead>
                    <b-tbody>
                      <b-tr>
                        <b-td> {{ category.name }} </b-td>
                        <b-td> {{ meal.label }} </b-td>
                        <b-td> {{model.params.checkIn}} </b-td>
                        <b-td> {{model.params.checkOut}} </b-td>
                        <b-td> {{duration}} </b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table-simple stacked="sm" striped caption-top  class="table table-sm text-center">
                  <caption class="pl-2 pl-sm-0 pb-0"><h6 class="package-title" v-translate>Passengers and room details</h6></caption>
                  <b-thead class="t-head thead-light text-center">
                    <b-tr>
                      <b-td><translate>Room</translate></b-td>
                      <b-td></b-td>
                      <b-td><translate>Last name</translate>*</b-td>
                      <b-td><translate>First name</translate>*</b-td>
                      <b-td><translate>Age</translate></b-td>
                      <b-td><translate>Date of birth</translate>*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody v-for="(room,rIndex) in pax" :key="rIndex">
                    <template v-for="(p, pIndex) in room">
                      <PaxForm
                        v-model="room[pIndex]"
                        :travelDate="travelDate"
                        :room="rIndex + 1"
                        :id="'room' + rIndex + 'pax' + pIndex"
                        :key="'pax' + pIndex"
                      />
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <hr>
                <p style="color: rgb(112, 99, 90); font-size: 13px; margin-bottom:0;"><em>*<translate>Fields marked with asterisks are required.</translate></em></p>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col>
                <h6><translate>Agent notes</translate>*</h6>
                <textarea v-model="notes" class="form-control">...</textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-card class="mb-2">
                  <ValidationProvider
                    name="terms"
                    rules="is:acceptat"
                    vid="terms"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group>
                      <b-form-checkbox
                        id="conditions"
                        name="conditions"
                        v-model="termsAccepted"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="neacceptat"
                        >
                          <translate>I have read and agree to the </translate><span class="text-info"  @click="openTermsAndConditions" v-translate>Terms and Conditions</span> <translate>of the marketing products.</translate>
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)"><translate>you have not accepted the terms and conditions</translate></b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>
                </b-card>
              </b-col>
              <b-col md="5">
                <b-card
                  class="card-booking-price"
                >
                  <b-form-group>
                    <span><translate>Price</translate>: <span class="font-weight-bold">{{ price }} {{ params.currency }} </span> <small>(<translate>tax included</translate>)</small></span><br />
                    <small v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                      {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
                    </small>
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" /><translate>Back</translate></b-button>
                        <b-button variant="warning" size="sm" type="submit" v-translate>Book</b-button>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner :label="$gettext('Loading') + '...'" variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" title="Error" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
           <translate>There was a problem</translate>
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted"> - <translate>Unfortunately the reservation could not be registered because a problem occurred</translate>.</b-card-text>
          <b-card-text class="lead text-muted"> - <translate>Generally, this happens when the price or availability of the product has changed since you searched</translate>.</b-card-text>
          <b-card-text class="lead text-muted"> <translate>The error message is</translate>: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back" v-translate>Back to results</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" :title="$gettext('Terms and Conditions')" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsAndConditions/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions" v-translate>Save</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from 'b2b-common/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import HotelInfo from '@/app/private/shared/components/hotel_info'
import PaxForm from '@/app/private/shared/components/pax_form'
import TermsAndConditions from '../../shared/components/footer/terms_conditions'
import { $gettext } from '@/config/gettext'

import { search, book, paymentSchedule } from 'b2b-common/services/api/hotel'

const calculatePrice = (category, meal) => {
  const p = meal.price + meal.tax
  return p
}

const invalidFormMessage = $gettext('Invalid Form')

export default {
  mixins: [toast, auth, validation],
  props: ['params', 'result', 'pack', 'category', 'meal'],
  components: { HotelInfo, PaxForm, TermsAndConditions },
  computed: {
    price () {
      return calculatePrice(this.category, this.meal, this.selectedExtras)
    },
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  },
  data () {
    const travelDate = moment(this.params.checkIn, 'DD-MM-YYYY')

    const rooms = []
    let noAdults = 0
    let noChildren = 0
    this.params.rooms.forEach(room => {
      const pax = []
      noAdults += room.adults
      noChildren += room.ages.length
      for (let i = 0; i < room.adults; i++) {
        pax.push({
          title: 'Mr',
          fname: '',
          lname: '',
          age: 'adult',
          bdate: null
        })
      }
      room.ages.forEach(age => {
        pax.push({
          title: (age < 2) ? 'Inf' : 'Chd',
          fname: '',
          lname: '',
          age: age,
          bdate: null
        })
      })
      rooms.push(pax)
    })

    return {
      model,
      travelDate,
      noAdults,
      noChildren,
      notes: '',
      pax: rooms,
      termsAccepted: $gettext('unaccepted'),
      client: {
        clientCode: '',
        isCompany: false,
        companyName: '',
        companyNo: '',
        vatNo: '',
        bankAccount: '',
        bankName: '',
        title: 'Mr',
        firstName: '',
        lastName: '',
        idInfo: '',
        cnp: '',
        address1: '',
        address2: '',
        county: '',
        city: '',
        tel: '',
        email: ''
      },
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: $gettext('unknown error'),
      termsAndConditions: false,
      paymentSchedule: []
    }
  },
  async created () {
    this.paymentSchedule = await paymentSchedule({
      result: this.result.index,
      category: this.category.id,
      source: this.result.source,
      meal: this.meal.id
    })
  },
  methods: {
    back () {
      this.$emit('back')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    async book (isOption = false) {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: $gettext('Please fill in all required fields!'), variant: 'danger' })
          return Promise.reject(new Error(invalidFormMessage))
        }
        this.showOverlay = true
        this.overlayMessage = $gettext('Please wait, we check again the price and availability of the selected product ...')

        let bookParams = {}

        const pax = [...this.pax.map(room => room.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate
        })))]

        // run new search
        const newParams = model.params
        newParams.hotels = [this.result.id]
        model.params = newParams
        const data = await search(newParams)
        // re-populate model
        model.results = data
        model.sort({ sortMethod: model.sortMethod })

        let newResult = null
        let newCategory = null
        let newMeal = null

        model.results.forEach(result => {
          if (result.id === this.result.id) {
            newResult = result
            result.categories.forEach(category => {
              if (this.category.name === category.name &&
                category.hotelIsAvailable === this.category.hotelIsAvailable &&
                category.hotelIsBlackedOut === this.category.hotelIsBlackedOut &&
                category.isBookable === this.category.isBookable) {
                category.meals.forEach(meal => {
                  const p1 = meal.price + meal.tax
                  const p2 = this.meal.price + this.meal.tax
                  if (meal.code === this.meal.code &&
                  meal.label === this.meal.label &&
                  p1 === p2) {
                    newMeal = meal
                    newCategory = category
                  }
                })
              }
            })
          }
        })

        if (!newResult) throw new Error('Could not find hotel')
        if (!newCategory) throw new Error('Could not find category with similar availability')
        if (!newMeal) throw new Error('Could not find result with similar price')

        // now ok to create booking
        bookParams = {
          category: newCategory.id,
          meal: newMeal.id,
          notes: this.notes,
          pax: pax
        }
        if (isOption) bookParams.status = 'option'
        const res = await book(bookParams)
        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      }
      this.showOverlay = false
    },
    onExtraToggle (extraIndex) {
      const index = this.selectedExtras.indexOf(extraIndex)
      if (index >= 0) this.selectedExtras.splice(index, 1)
      else this.selectedExtras.push(extraIndex)
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      if (no === null || no === undefined) return null
      return Math.ceil(no) + this.params.currency
    }
  }
}
</script>
